/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaDefiProtocolListRequest = {
    sortField?: SomniaDefiProtocolListRequest.sortField;
    sortDirection?: SomniaDefiProtocolListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace SomniaDefiProtocolListRequest {

    export enum sortField {
        TVL = 'TVL',
        TVL_CHANGE_1D = 'TVL_CHANGE_1D',
        TVL_CHANGE_7D = 'TVL_CHANGE_7D',
        TVL_CHANGE_30D = 'TVL_CHANGE_30D',
        REVENUE_30D = 'REVENUE_30D',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

